// This file is auto-generated don't edit it!
import { Component } from '@angular/core';

@Component({
    selector: 'ui-icon-docs',
    templateUrl: './icon.docs.generated.html',
})
export class UIIconDocs { }
